import { z } from "zod";

import {
  UPLOAD_ALLOWED_CONTENT_TYPES,
  UPLOAD_MAX_FILE_SIZE,
  UPLOAD_MIN_FILE_SIZE
} from "../constants/upload";

export const SubscriptionReqSchema = z.object({
  email: z.string().email("Invalid email format")
});
export type SubscriptionReq = z.infer<typeof SubscriptionReqSchema>;

export const UploadImageRespSchema = z.object({
  url: z.string().url(),
  key: z.string()
});
export type UploadImageResp = z.infer<typeof UploadImageRespSchema>;

export const BasePresignedReqSchema = z.object({
  fileSize: z.coerce.number().int().min(UPLOAD_MIN_FILE_SIZE).max(UPLOAD_MAX_FILE_SIZE),
  fileName: z.string().min(1).max(255),
  contentType: z.enum(UPLOAD_ALLOWED_CONTENT_TYPES)
});

export enum PresignedType {
  // USER
  USER_AVATAR = "USER_AVATAR",

  // ORG
  ORG_AVATAR = "ORG_AVATAR",
  ORG_BANNER = "ORG_BANNER",

  // PROGRAM
  PROGRAM_BANNER = "PROGRAM_BANNER",

  // UNKNOWN
  UNKNOWN = "UNKNOWN"
}
export const PresignedTypeSchema = z.nativeEnum(PresignedType);

export const PresignedReqSchema = z.discriminatedUnion("uploadType", [
  // USER
  BasePresignedReqSchema.extend({
    uploadType: z.literal(PresignedType.USER_AVATAR),
    userId: z.string().nullish()
  }),

  // ORG
  BasePresignedReqSchema.extend({
    uploadType: z.literal(PresignedType.ORG_AVATAR),
    orgId: z.string()
  }),
  BasePresignedReqSchema.extend({
    uploadType: z.literal(PresignedType.ORG_BANNER),
    orgId: z.string()
  }),

  // PROGRAM
  BasePresignedReqSchema.extend({
    uploadType: z.literal(PresignedType.PROGRAM_BANNER),
    programId: z.string()
  }),

  // UNKNOWN
  BasePresignedReqSchema.extend({
    uploadType: z.literal(PresignedType.UNKNOWN)
  })
]);
export type PresignedReq = z.infer<typeof PresignedReqSchema>;

export const PresignedRespSchema = z.object({
  url: z.string().url(),
  key: z.string()
});

export type PresignedResp = z.infer<typeof PresignedRespSchema>;
